<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;">
          <div class="">
            <el-row style="display: flex;justify-content: flex-end;">
              <el-tooltip class="item" effect="dark" content="保存设置" placement="top">
                <el-button type="danger" round @click="savePointSettings">保存设置</el-button>
              </el-tooltip>
            </el-row>
          </div>
        </div>

        <div style="padding: 0px;">
          <div style="text-align: center;font-size: 18px;font-weight: bold;margin-bottom: 10px;">
            设置"{{exam_name}}"手机端查询结果小数点显示位数</div>
          <el-table border :data="course_points" stripe style="width: 100%;"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}">
            <el-table-column type="index" label="序号" width="50" header-align="center" align="center">
            </el-table-column>
            <el-table-column prop="course_name" label="科目名称">
            </el-table-column>

            <el-table-column label="手机端查询结果显示的小数点位数" header-align="center" align="center" width="400">
              <template slot-scope="scope">
                <div style="display: flex;justify-content: center;">
                  保留<input type="number" v-model="point_num[scope.$index]" style="font-size: 16px;text-align:center;"
                    placeholder="默认" />位小数
                  <!--                  <el-input-number v-model="point_num[scope.$index]" :min="0" :max="3" label="小数点保留位数">
                  </el-input-number> -->
                </div>
              </template>
            </el-table-column>

          </el-table>
          <div style="color: red;text-align: center;margin-top: 10px;font-size: 16px;">说明：显示“默认”表示不设置,导入什么显示什么.</div>

          <div style="padding: 10px;">
            <div class="">
              <el-row style="display: flex;justify-content: flex-end;">
                <el-tooltip class="item" effect="dark" content="保存设置" placement="top">
                  <el-button type="danger" round @click="savePointSettings">保存设置</el-button>
                </el-tooltip>
              </el-row>
            </div>
          </div>

        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        course_points: [],
        course_names: [],
        exam_id: '',
        cousers: [],
        point_num: [],
        exam_name: '',

        dateList: ['全部'],
        filterCondition: '',
        students: [],
        username: '',
        tableData: [],
        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        selectedExamID: '',
        msg: '',
        configurations: [],
        showPosition: false,
        unReadDialogFormVisible: false,

        shownotify: 0,
        successDialogVisible: false,

        showScoreAvg: false,
        showSection: false,
        showAvgTrend: false,
        unlockDialogVisible: false,
        unlockForm: {
          student_name: '',
          student_num: ''
        },

        img_url: ''

      }
    },
    mounted() {
      this.username = this.$session.get('USERNAME') // 获取session
    },
    created() {
      console.log('调用exam_list created')
      this.username = this.$session.get('USERNAME') // 获取session
      this.exam_id = this.$route.params.id
      this.exam_name = this.$route.params.exam_name

      // this.loadDateList()
      this.loadData()
    },
    methods: {
      loadData() {
        console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_load_course_of_exam_point.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username,
              exam_id: that.exam_id
            }
          }).then(function(response) {
            that.course_points = response.data.course_points

            console.log('dddddddddddd', that.course_points)


            for (var i = 0; i < that.course_points.length; i++) {
              let course = that.course_points[i]
              that.point_num[i] = course.course_point
              that.course_names[i] = course.course_name
            }

            // console.log('dddddddssssssssss',that.course_names)

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      savePointSettings(index, rows) {
        let that = this

        let data = {
          exam_id: that.exam_id,
          courses: JSON.stringify(that.course_points),
          points: JSON.stringify(that.point_num),
          names: JSON.stringify(that.course_names)
        }

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var qs = require('qs')

        // 注册接口
        var requestUrl = '/score/web/_save_course_of_exam_point.jsp'
        this.axios.post(requestUrl,
            qs.stringify(data), {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          ).then(function(response) {
            that.$message.success('保存成功！')
            load.close()
            that.$router.push('/exam_list')
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      closeUnreadDialog() {
        this.unReadDialogFormVisible = false
      },
      filterExams(date) {
        console.log(date)
      },
      selectChanged() {
        console.log(this.filterCondition)
        this.loadData()
      },
      phoneShowSetting() {
        this.searchResultSettingDialogTableVisible = true
      },
      loadSetting() {
        let that = this
        var requestUrl = '/score/web/_load_settings.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            let list = response.data

            console.log(list)

            for (var i = 0; i < list.length; i++) {
              var settingName = list[i].setting_name
              var settingValue = list[i].setting_value

              console.log(settingName + '=' + settingValue)

              if (settingName === 'intShowScoreAvg') {
                if (settingValue === '1') {
                  that.showScoreAvg = true
                } else {
                  that.showScoreAvg = false
                }
              }

              if (settingName === 'intShowSection') {
                if (settingValue === '1') {
                  that.showSection = true
                } else {
                  that.showSection = false
                }
              }

              if (settingName === 'intShowAvgTrend') {
                if (settingValue === '1') {
                  that.showAvgTrend = true
                } else {
                  that.showAvgTrend = false
                }
              }
            }
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      closeSettings() {
        this.searchResultSettingDialogTableVisible = false
        this.loadSetting()
      },
      unlockPhone() {
        this.unlockDialogVisible = true
      },
      unlockAllPhone() {
        let that = this

        this.$confirm('确定要解锁所有手机吗?', '操作提醒', {
          confirmButtonText: '全部解锁',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 开启loading
          const load = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })

          var requestUrl = '/score/web/_unlock_all.jsp'
          this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            console.log(response)

            if (response.data.result === '1') {
              that.$message.success('解锁成功！！')
            } else {
              that.$message.error(response.data.message)
            }

            load.close()
          }).catch(function(error) {
            console.log(error)
            load.close()
          })
        }).catch(() => {

        })
      },
      importedNextStep() {
        this.successDialogVisible = true
      },
      unlock() {
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/score/web/_unlock.jsp'
        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            student_name: that.unlockForm.student_name,
            student_num: that.unlockForm.student_num
          }
        }).then(function(response) {
          console.log(response)

          if (response.data.result === '1') {
            that.$message.success('解锁成功！！')
          } else {
            that.$message.error(response.data.message)
          }

          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })

        this.unlockDialogVisible = false
      },
      exportStudents() {
        let that = this

        var qrcodeRequestUrl = '/score/web/_qrcode.jsp'
        this.axios.get(qrcodeRequestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            let tmpFile = response.data.filename
            that.qrcode_img_url = '/score' + tmpFile
            console.log(this.qrcode_img_url)
          })
          .catch(function(error) {
            console.log(error)
          })

        var requestUrl = '/score/web/_export_students_to_excel.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            console.log(response.data)
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      convertPostion(index) {
        if (index === 0) {
          return '直接显示查询结果'
        } else {
          return '历次成绩单'
        }
      }

    },
    watch: {
      $route() {
        this.loadData()
      }
    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>


// WEBPACK FOOTER //
// src/components/point_settings.vue